import { useCallback, useEffect, useState } from "react";

import {
  type BrowserFailureArea,
  type BrowserFailureItem,
  clearBrowserFailures,
  readBrowserFailures,
  subscribeBrowserFailures,
} from "./browser-observability";

export interface UseBrowserFailuresResult {
  items: BrowserFailureItem[];
  captureConfigured: boolean;
  clear: () => void;
  refresh: () => void;
}

export function useBrowserFailures(
  area: BrowserFailureArea = "organization"
): UseBrowserFailuresResult {
  const [items, setItems] = useState<BrowserFailureItem[]>(() => readBrowserFailures(area));

  const refresh = useCallback(() => {
    setItems(readBrowserFailures(area));
  }, [area]);

  useEffect(() => {
    refresh();
    return subscribeBrowserFailures(refresh);
  }, [refresh]);

  return {
    items,
    captureConfigured: true,
    clear: () => {
      clearBrowserFailures(area);
      refresh();
    },
    refresh,
  };
}
